import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { UserAttr } from '../../../interfaces/admin/Users';

@Component({
  selector: 'app-user-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule
  ],
  templateUrl: './user-dialog.component.html',
  styleUrl: './user-dialog.component.scss'
})
export class UserDialogComponent {
  readonly user = inject<UserAttr | undefined>(MAT_DIALOG_DATA, { optional: true });

  readonly displayName = this.user?.user_name || this.user?.loginId || 'Account';
  readonly initials = this.getInitials(this.displayName);

  readonly fields = [
    { label: 'Name', value: this.user?.user_name },
    { label: 'Email', value: this.user?.user_email },
    { label: 'Login ID', value: this.user?.loginId },
    { label: 'User ID', value: this.user?.user_id },
    { label: 'Country', value: this.user?.country },
    { label: 'Language', value: this.user?.selected_lang }
  ];

  private getInitials(value: string): string {
    return value
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part.charAt(0).toUpperCase())
      .join('');
  }
}
